import {$host} from "./index";
import axios from "axios";

export const login = async (email, password) => {
    return await $host.post('tokens', {email, password})
}

export const checkAuth = async (userId) => {
    return await $host.get(`users/${userId}`,)
}

export const fetchCert = async (url, auth) => {
    return await axios.get(url, {auth, responseType: 'text'});
}
